module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.appKey,
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? [_c('div', {
    staticClass: "ajax-backdrop-loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLoader || '/static/img/loader.gif'
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$store.state.lang === 'en' ? 'Authentication check...' : 'Проверка аутентификации...'))])])] : [(_vm.errorMessage !== false) ? _c('errorPage', {
    attrs: {
      "message": _vm.errorMessage,
      "code": _vm.errorCode
    }
  }) : [(_vm.$store.state.is_auth === true && _vm.$route.path.indexOf('/unsubscribe') !== 0 && _vm.$route.path !== '/503' && _vm.$route.path !== '/user/check' && _vm.$route.path !== '/email/check') ? _c('workBoard') : (!_vm.$store.state.is_auth && (_vm.$route.path.indexOf('/operation/select/') === 0 || _vm.$route.path.indexOf('/operation/pay/') === 0 || _vm.$route.path.indexOf('/operation/view/') === 0 || _vm.$route.path === '/operation/list')) ? _c('operationPage') : _c('unauthPage'), _vm._v(" "), (_vm.$store.state.is_auth !== true &&
    (
      _vm.$route.path.indexOf('/unsubscribe') === 0 ||
      _vm.$route.path === '/503' ||
      _vm.$route.path === '/user/check' ||
      _vm.$route.path === '/email/check' ||
      _vm.$route.path === '/operation/list' ||
      _vm.$route.path === '/login' ||
      _vm.$route.path === '/register' ||
      _vm.$route.path === '/forget' ||
      _vm.$route.path.indexOf('/operation/select/') === 0 ||
      _vm.$route.path.indexOf('/operation/pay/') === 0 ||
      _vm.$route.path.indexOf('/operation/view/') === 0
    )) ? _c('Lang', {
    attrs: {
      "fixed": true
    }
  }) : _vm._e()]], _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.longRequest),
      expression: "this.$store.state.longRequest"
    }],
    staticClass: "ajax-backdrop-loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLoader || '/static/img/loader.gif'
    }
  }), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/loading')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUpdatePanelButton),
      expression: "showUpdatePanelButton"
    }],
    staticClass: "w5-cp-update-button"
  }, [_c('div', {
    staticClass: "w5-pulse-inner",
    on: {
      "click": _vm.showUpdateBlock
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-pulse-outter"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUpdatePanelMessageBlock),
      expression: "showUpdatePanelMessageBlock"
    }],
    staticClass: "w5-cp-update-warning alert alert-warning"
  }, [_vm._v("\n\t" + _vm._s(_vm.messagesForUpdateBlock[0]) + "\n\t"), _c('span', {
    on: {
      "click": _vm.reloadApp
    }
  }, [_vm._v(_vm._s(_vm.messagesForUpdateBlock[1]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.applicationBlocked),
      expression: "this.$store.state.applicationBlocked"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/refresh_screen')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.AppName === 'vdsina' || _vm.AppName === 'vdsina.com') ? _c('img', {
    staticStyle: {
      "width": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("./assets/img/idle.png"),
      "align": "left"
    }
  }) : (_vm.AppName === 'macloud') ? _c('img', {
    staticStyle: {
      "width": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("./assets/img/idle-mc.png"),
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/user_idle_state_text')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-small pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])])])])]), _vm._v(" "), (_vm.clientWarnings && _vm.clientWarnings.length && _vm.clientWarnings[0].subject && _vm.clientWarnings[0].content) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper warnings"
  }, [_c('div', {
    staticClass: "modal-container warnings",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.clientWarnings[0].subject)))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.clientWarnings[0].content_type === 'html') ? _c('p', {
    staticStyle: {
      "margin": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.clientWarnings[0].content)
    }
  }) : _c('p', {
    directives: [{
      name: "formatTicketMessage",
      rawName: "v-formatTicketMessage",
      value: ({
        'message': {
          message_content_type: _vm.clientWarnings[0].content_type,
          message_content: _vm.clientWarnings[0].content
        },
        'fastSearchValue': null
      }),
      expression: "{\n\t\t\t\t\t\t'message': {\n\t\t\t\t\t\t\tmessage_content_type: clientWarnings[0].content_type,\n\t\t\t\t\t\t\tmessage_content: clientWarnings[0].content\n\t\t\t\t\t\t},\n\t\t\t\t\t\t'fastSearchValue': null\n\t\t\t\t\t}"
    }],
    staticStyle: {
      "margin": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "w5-field close-client-warning pull-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientWarningsCloseValue),
      expression: "clientWarningsCloseValue"
    }],
    staticClass: "w5-checkbox-field",
    attrs: {
      "id": "closeClientWarning",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clientWarningsCloseValue) ? _vm._i(_vm.clientWarningsCloseValue, null) > -1 : (_vm.clientWarningsCloseValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clientWarningsCloseValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clientWarningsCloseValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.clientWarningsCloseValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clientWarningsCloseValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "closeClientWarning"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/never_show')))])]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit-danger btn-submut pull-right btn-warn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeWarning($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/close')))]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submut pull-right btn-warn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.gotoWarningTicket($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/ticket')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.is_auth === true && _vm.$route.path.indexOf('/unsubscribe') !== 0 && _vm.$route.path !== '/503' && _vm.$route.path !== '/user/check' && _vm.$route.path !== '/email/check') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserNeedDialogModal),
      expression: "showUserNeedDialogModal"
    }],
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.userNeedDialogTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideUserNeedDialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fieldsUserNeed && _vm.fieldsUserNeed.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("ftc")(_vm.userNeedDialogMode === 'password' ? 'user/need_password_change' : 'user/need_email_confirm')))]), _vm._v(" "), (_vm.userNeedDialogMode === 'password') ? _vm._l((_vm.fieldsUserNeed.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row v-center': _vm.isVisibleField(row)
      }
    }, [_vm._l((row), function(field) {
      return [_c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "userneed",
          "action": "update",
          "Field": field
        },
        on: {
          "blur": function($event) {
            return _vm.onBlurInput(field)
          },
          "focus": function($event) {
            return _vm.onFocusInput(field)
          },
          "enterKeyDown": _vm.submitUserNeedForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })]
    })], 2) : _vm._e()
  }) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldEmailError),
      expression: "fieldEmailError"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.fieldEmailError)),
      expression: "localeFtc(fieldEmailError)"
    }],
    staticClass: "alert alert-danger w5-alert-valid email-create",
    attrs: {
      "role": "alert"
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-in-dialog",
    on: {
      "click": _vm.submitUserNeedForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.userNeedDialogMode === 'password' ? 'main/continue' : 'main/confirm')))])])])])]) : _vm._e(), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "modal-scroll-arrow",
    attrs: {
      "id": "modal-scroll-arrow-up",
      "icon": "long-arrow-alt-up"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "modal-scroll-arrow",
    attrs: {
      "id": "modal-scroll-arrow-down",
      "icon": "long-arrow-alt-down"
    }
  }), _vm._v(" "), _c('Notificator'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "for-retina-detection"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioBlock",
    attrs: {
      "src": "/static/snd/block.mp3"
    }
  }), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? _c('div', {
    staticClass: "w5-version-info"
  }, [_vm._v("\n\t" + _vm._s(_vm.clVersion) + "\n\t"), _c('br'), _vm._v("\n\t" + _vm._s(this.$store.state.apiVersion) + "\n")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aa9a9de"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 779
// module chunks = 0